import React from 'react';
import strings from '../../../../constants/strings.constants';
import Typo from '../../../../components/atom/Typo';
import Button from '../../../../components/atom/Button';
import colors from '../../../../constants/colors.constants';
import { ReactComponent as IconFinger } from '../../../../assets/svgs/icon-finger.svg';
import { ReactComponent as IconChat } from '../../../../assets/svgs/icon-chat.svg';
import AuthBottomSheet from '../../../../components/compositions/AuthBottomSheet/AuthBottomSheet';
import useAuthStore from '../../../../store/useAuthStore';
import { ROUTER_PATHS } from '../../../../routes/routes.constatns';
import { useLocation, useNavigate } from 'react-router-dom';
import { getTreatmentReservationPath } from '../../../../hard-coded/hardCoding';
import { Sheet } from 'react-modal-sheet';
import { sendViewItemListEvent } from '../../../../utils/ga-utils';

// 문구가 줄바꿈되면 버튼 높이가 늘어나도록 고정 높이 대신 최소 높이 사용
const menuButtonStyle: React.CSSProperties = {
  height: 'auto',
  minHeight: 56,
  padding: '8px 16px',
};

export interface ReservationMenuBottomSheetProps {
  visible?: boolean;
  onCancel?: () => void;
}

function ReservationMenuBottomSheet(props: ReservationMenuBottomSheetProps) {
  const { visible = false, onCancel } = props;
  const { customer, partner } = useAuthStore();
  const [authBottomSheetVisible, setAuthBottomSheetVisible] =
    React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const useProductReservation =
    partner?.productViewConfig?.mimoWebViewConfig?.useProductReservation ??
    true;
  const useConsultingReservation =
    partner?.productViewConfig?.mimoWebViewConfig?.useConsultingReservation ??
    true;

  // 최근 진료 재예약
  const routeRevisitReservation = () => {
    navigate({
      pathname: ROUTER_PATHS.REVISIT_RESERVATION,
      search: location.search,
    });
  };

  // 시술 예약
  const routeTreatmentReservation = () => {
    if (!partner) {
      return;
    }

    sendViewItemListEvent({ itemListName: 'ALL' });
    const path = getTreatmentReservationPath(partner);

    navigate({
      pathname: path,
      search: location.search,
    });
  };

  // 상담 예약
  const routeConsultingReservation = () => {
    navigate({
      pathname: ROUTER_PATHS.CONSULTING_RESERVATION,
      search: location.search,
    });
  };

  return (
    <Sheet
      avoidKeyboard={false}
      detent="content"
      isOpen={visible}
      onClose={() => {
        if (onCancel) onCancel();
      }}
      style={{
        zIndex: 10,
      }}
      tweenConfig={{ ease: 'easeOut', duration: 0.4 }}
    >
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className="p-[20px] pb-[48px]">
            <div className="flex flex-col">
              <Typo
                style={{
                  textAlign: 'center',
                  marginBottom: 18,
                }}
                type="r-18"
              >
                {strings.selectReservationMenu}
              </Typo>
              <div className="flex flex-col gap-[10px]">
                <Button
                  type="primary"
                  style={menuButtonStyle}
                  onClick={() => {
                    if (customer) {
                      routeRevisitReservation();
                    } else {
                      setAuthBottomSheetVisible(true);
                    }
                  }}
                >
                  <IconFinger className="shrink-0" />
                  {strings.revisitReservationButtonTitle}
                </Button>
                {useProductReservation && (
                  <Button
                    style={{
                      ...menuButtonStyle,
                      background: 'white',
                      color: colors.black,
                      border: `1px solid ${colors.black}`,
                    }}
                    onClick={() => {
                      routeTreatmentReservation();
                    }}
                  >
                    <IconFinger className="shrink-0" stroke={colors.black} />
                    {strings.treatmentReservationButtonTitle}
                  </Button>
                )}

                {useConsultingReservation && (
                  <Button
                    style={{
                      ...menuButtonStyle,
                      background: 'white',
                      color: colors.black,
                      border: `1px solid ${colors.black}`,
                    }}
                    onClick={() => {
                      routeConsultingReservation();
                    }}
                  >
                    <IconChat className="shrink-0" />
                    {strings.consultingReservationButtonTitle}
                  </Button>
                )}
              </div>
            </div>
          </div>
          <AuthBottomSheet
            visible={authBottomSheetVisible}
            onCancel={() => {
              setAuthBottomSheetVisible(false);
            }}
            onAuthComplete={() => {
              routeRevisitReservation();
            }}
          />
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop
        onTap={() => {
          if (onCancel) onCancel();
        }}
      />
    </Sheet>
  );
}

export default ReservationMenuBottomSheet;
